<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("orders.newOrder") }}
      </p>
    </header>

    <section class="modal-card-body">
      <div class="columns">
        <div class="column is-one-quarter">
          <b-field
            :label="`${$t('orders.orderId')} ${$t('orders.(optional)')}`"
          >
            <b-input v-model="orderId" placeholder="1234"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field
            :label="`${$t('orders.description')} ${$t('orders.(optional)')}`"
          >
            <b-input
              v-model="description"
              :placeholder="$t('orders.descriptionPlaceholder')"
            ></b-input>
          </b-field>
        </div>
      </div>

      <b-field :label="$t('orders.maxInstallments')"></b-field>
      <div class="block">
        <b-radio
          v-model="maxInstallments"
          name="maxInstallments"
          :native-value="1"
        >
          1
        </b-radio>

        <b-radio
          v-model="maxInstallments"
          name="maxInstallments"
          :native-value="2"
          style="margin-left: 0.75rem;"
        >
          2
        </b-radio>

        <b-radio
          v-model="maxInstallments"
          name="maxInstallments"
          :native-value="3"
          style="margin-left: 0.75rem;"
        >
          3
        </b-radio>

        <b-radio
          v-model="maxInstallments"
          name="maxInstallments"
          :native-value="4"
          style="margin-left: 0.75rem;"
        >
          4
        </b-radio>

        <b-radio
          v-model="maxInstallments"
          name="maxInstallments"
          :native-value="5"
          style="margin-left: 0.75rem;"
        >
          5
        </b-radio>

        <b-radio
          v-model="maxInstallments"
          name="maxInstallments"
          :native-value="6"
          style="margin-left: 0.75rem;"
        >
          6
        </b-radio>
      </div>

      <b-field :label="$t('orders.addProductsToCart')">
        <b-autocomplete
          v-model="product"
          ref="product"
          :data="filteredProductsArray"
          placeholder="Ex: Coca-cola lata 350ml"
          field="n"
          clearable
          keep-first
          @select="option => (selected = option)"
          :key="key"
        >
          <template #empty>{{ $t("orders.noResultsFound") }}</template>
        </b-autocomplete>
      </b-field>

      <p
        v-if="this.cart.items.length === 0"
        class="has-text-centered"
        style="margin-top: 3rem; margin-bottom: 3rem;"
      >
        {{ $t("orders.cartIsEmpty") }}
      </p>

      <div v-else>
        <cart-item
          v-for="product in this.cart.items"
          :product="product"
          :key="product.productId"
          @increment-item-quantity="incrementItemQuantity"
          @decrement-item-quantity="decrementItemQuantity"
        />

        <cart-total :cart="cart" />
      </div>

      <span id="paymentlink" v-show="false"></span>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        type="button"
        @click="makeOrder"
        v-if="permissions.makeOrder"
      >
        {{ $t("orders.makeOrder") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import cartItem from "./CartItem";
import cartTotal from "./CartTotal";

export default {
  mixins: [common],

  components: {
    cartItem,
    cartTotal
  },

  data() {
    return {
      // user: {
      //   personalInfo: {
      //     name: "",
      //     email: "",
      //     countryCallingCode: "",
      //     cellphone: "",
      //     personalId: ""
      //   },
      //   address: {

      //   }
      // },

      orderId: "",
      description: "",
      maxInstallments: 1,

      product: "",
      selected: "",
      key: 0,
      isLoading: false
    };
  },

  methods: {
    getProductsForOrder() {
      this.isLoading = true;
      this.$store
        .dispatch("getProductsForOrder", this.storeBeingManaged._id)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    incrementItemQuantity(barcode) {
      const productIndex = this.products.findIndex(p => p.b === barcode);
      this.$store.dispatch("addProduct", this.products[productIndex]);
    },

    decrementItemQuantity(barcode) {
      const productIndex = this.products.findIndex(p => p.b === barcode);
      this.$store.dispatch("removeProduct", this.products[productIndex]);
      if (this.cart.items.findIndex(p => p.barcode === barcode) === -1) {
        this.isItemDetailsModalOpen = false;
      }
    },

    makeOrder() {
      this.isLoading = true;

      const totalValue = Number(this.cart.totalValue.toFixed(2)) * 100;

      // TODO: cart.items.price should not be in cents?
      const cart = JSON.parse(JSON.stringify(this.cart));
      cart.totalValue = totalValue;

      for (let i = 0; i < cart.items.length; i++) {
        cart.items[i].price = Number(cart.items[i].price.toFixed(2)) * 100;
      }

      this.$store
        .dispatch("makeOrder", {
          cart,
          orderId: this.orderId,
          description: this.description,
          maxInstallments: this.maxInstallments,
          storeId: this.storeBeingManaged._id
        })
        .then(res => {
          if (res.data.result === "ok") {
            document.getElementById("paymentlink").innerHTML =
              res.data.payload.order.paymentLink;
            this.$buefy.dialog.confirm({
              title: this.$t("orders.orderConfirmed"),
              message: `${this.$t("orders.paymentLink")}: ${
                res.data.payload.order.paymentLink
              }`,
              type: "is-success",
              hasIcon: true,
              icon: "check-circle",
              iconPack: "fa",
              confirmText: this.$t("orders.copyAndClose"),
              cancelText: this.$t("common.cancel"),
              onCancel: () => this.$parent.close(),
              onConfirm: () => {
                this.copyPaymentLink();
                this.$parent.close();
              }
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    copyPaymentLink() {
      const doc = document;

      const clone = doc.querySelector(`#paymentlink`).cloneNode(true);
      clone.style = "position: absolute; left: -1000px; top: -1000px";
      clone.id = "clone";
      doc.body.appendChild(clone);

      const text = doc.querySelector(`#clone`);
      let range;
      let selection;

      if (doc.body.createTextRange) {
        range = doc.body.createTextRange();
        range.moveToElement(text);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = doc.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      try {
        if (document.execCommand("copy")) {
          this.$buefy.toast.open({
            message: this.$t("orders.linkCopied"),
            type: "is-primary"
          });
        } else {
          this.alertError({ message: "COPY_FAILED" });
        }
      } catch (err) {
        this.alertError({ message: "COPY_FAILED" });
      }

      window.getSelection().removeAllRanges();
      doc.body.removeChild(clone);
    }
  },

  computed: {
    ...mapGetters(["storeBeingManaged", "products", "permissions", "cart"]),

    filteredProductsArray() {
      return this.products.filter(option => {
        return (
          option.n
            .toString()
            .toLowerCase()
            .indexOf(this.product.toLowerCase()) >= 0
        );
      });
    }
  },

  watch: {
    selected() {
      if (
        this.selected !== "" &&
        this.selected !== null &&
        typeof this.selected === "object" &&
        this.selected.hasOwnProperty("n")
      ) {
        this.$store.dispatch("addProduct", this.selected);
        this.selected = "";
        this.product = "";
        this.key++;
        this.$nextTick(() => {
          this.$refs.product.focus();
        });
      }
    }
  },

  mounted() {
    this.$store.dispatch("emptyCart");
    this.getProductsForOrder();
  }
};
</script>
